import React, { useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import { scrollIntoView } from "seamless-scroll-polyfill";
import AddToCartForm from "./AddToCartForm";
import Button from "../../components/Button";
import Carousel from "../../components/Carousel";
import Bands from "./Bands";
import ArrowRightIcon from "@heroicons/react/24/outline/ArrowRightIcon";
import VideoModal from "../../components/VideoModal";

const SwiperImages = [
  "bands1.png",
  "bands2.png",
  "bands3.png",
  "bands4.png",
  "bands5.png",
  "bands6.png",
  "bands7.png",
];

export default function Page() {
  const nextButtonRef = useRef(null);
  const scrollToElement = () => {
    if (nextButtonRef.current) {
      scrollIntoView(nextButtonRef.current, {
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }
  };
  const [isOpenVideo, setIsOpenVideo] = useState(false);

  return (
    <section className="container mx-auto flex-1 p-5 flex flex-col lg:max-w-full relative">
      <div className="grid-cols-1 flex flex-col-reverse lg:grid lg:grid-cols-2 lg:flex-row flex-1 gap-14">
        <div className="relative flex flex-col  mt-5 md:mt-5 bg-[#302b2b] p-6 rounded-[1rem]">
          <h1 className="pb-4 md:pb-0 md:text-7xl text-5xl roboto-medium">
            <span className="text-white">B</span>
            <span className="text-[#00adef] mr-3">3</span>
            <span className="text-white">Bands</span>
          </h1>
          <img
            alt="30Day Icon"
            src="./assets/images/30days-free.png"
            className="w-[80px] h-[80px] md:w-[130px] md:h-[130px] absolute top-[-30px] right-[-20px] md:top-[-35px] md:right-[-45px]"
          />
          <Bands />
          <div className="">
            <AddToCartForm onClose={scrollToElement} />
          </div>
        </div>
        <div className="block my-auto mb-6 md:mb-auto items-center">
          <Carousel swiperImages={SwiperImages} />

          <div className="mt-16">
            <VideoModal
              open={isOpenVideo}
              setOpen={setIsOpenVideo}
              videoId="1045362105"
            />
          </div>
        </div>
      </div>
      <div className="w-full flex justify-center mt-10 mb-7 flex-row items-center">
        <NavLink
          key="business-opportunity"
          to="/business-opportunity"
          ref={nextButtonRef}
        >
          <Button className="uppercase text-xs md:text-base px-4 py-1 rounded-full font-light w-auto">
            Next
            <div className="inline-block pl-1 relative top-[3px]">
              <ArrowRightIcon
                fill="white"
                className="h-[0.9rem] md:h-[1.1rem] w-[1.1rem]"
                aria-hidden="true"
                color="white"
              />
            </div>
          </Button>
        </NavLink>
      </div>
    </section>
  );
}
